import axios from 'axios'
const instance = axios.create({
    baseURL: 'http://api.shgg.ltd/',
    timeout: 10000,
    headers: { 'X-Custom-Header': 'foobar' }
  })
  export default instance

